import { Component, ElementRef, EventEmitter, HostListener, inject, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { GeneralService } from "../../services/general.service";
import { SesionService } from "../../services/sesion.service";
import { WebServicesService } from "../../services/web-services.service";
// import { Title } from "@angular/platform-browser";
import { Injectable, Renderer2 } from "@angular/core";
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDateStruct, NgbDatepickerI18n, NgbModal, NgbModalConfig, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import moment from "moment";
import { FlatpickrOptions } from "ng2-flatpickr";
import { Texto_sitio } from "src/assets/text_site";
import Swal from "sweetalert2";
import { AllLocalStorageService } from "../../services/all-local-storage.service";
import { CommonModule } from "@angular/common";
import { NgSelectModule } from '@ng-select/ng-select';
import { FiltroListaComponent } from "../filtro-lista/filtro-lista.component";
import { environment } from "src/environments/environment";
import { DeviceDetectorService } from "ngx-device-detector";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from "rxjs";

const I18N_VALUES = {
  es: {
    weekdays: ["L", "M", "M", "J", "V", "S", "D"],
    months: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
  },
};

@Injectable()
export class I18n {
  language = "es";
}

@Injectable()
export class CustomDatepickerI18nService extends NgbDatepickerI18n {
  constructor(private _i18n: I18n) {
    super();
  }
  getWeekdayLabel(weekday: number): string {
    return I18N_VALUES.es.weekdays[weekday - 1];
  }
  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}

@Injectable()
export class CustomDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (!value) return null;
    let parts = value.split("/");
    return { year: +parts[0], month: +parts[1], day: +parts[2] } as NgbDateStruct;
  }
  format(date: NgbDateStruct): string {
    return date ? ("0" + date.day).slice(-2) + "-" + ("0" + date.month).slice(-2) + "-" + date.year : null;
  }
}

@Component({
  selector: "app-barra-busqueda-buses",
  templateUrl: "./barra-busqueda-buses.component.html",
  styleUrls: ["./barra-busqueda-buses.component.scss"],
  providers: [
    NgbModalConfig,
    NgbModal,
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18nService },
    WebServicesService,
    GeneralService,
    SesionService,
    AllLocalStorageService,
    Texto_sitio,
    FormBuilder
  ],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    TranslateModule,
    FormsModule,
    FiltroListaComponent
  ],
  standalone: true,
})
export class BarraBusquedaBusesComponent implements OnInit, OnDestroy {

  public opcionesFechaIda: FlatpickrOptions = {
    altInput: true,
    altFormat: "d-m-Y",
    defaultDate: new Date(),
    minDate: new Date(),
    allowInput: true,
  };

  public opcionesFechaVuelta: FlatpickrOptions = {
    altInput: true,
    altFormat: "d-m-Y",
    defaultDate: new Date(),
    minDate: new Date(),
    allowInput: true,
  };

  cities: any = [];
  model: any;
  form: FormGroup;
  formFiltroCiudadOrigen: FormGroup;
  activeId: any = 1;
  date: Date = new Date();
  history: any;
  minDateEnd: any;
  dateStarMobile: any;
  minDate: any;
  dateEndMobile: any = "";
  maxDateStart: any;
  lang: any;
  show: any = false;
  typeCalendar: any = 0;
  title: any;
  showList: any;
  dateStartMobile: any;
  navigation: any = 'arrows';
  outsideDays: any = 'visible';
  abrirOrigenViajeWeb = false;
  abrirDestinoViajeWeb = false;
  public CustomDayDPdata: NgbDateStruct;
  public today = this.calendar.getToday();
  isWeekend = (date: NgbDate) => this.calendar.getWeekday(date) >= 6;
  isDisabled = (date: NgbDate, current: { month: number; year: number }) => date.month !== current.month;
  titleList: any;
  placeholder: any;
  typeList: any;
  excludeList: any;
  names: any = [];
  properties: any = [];
  muestraBarra: any = false;
  modalRef: any;
  historialFechaIda: any;
  historialFechaReg: any;
  mesAComparar: any;
  dateStart: any;
  dateEnd: any;
  itemSearch: any;
  fechaMinimaVuelta: any;
  fechaMobile: any;
  day = 11;
  minDatePicker: any;

  @ViewChild("toggleButton") toggleButton: ElementRef;
  @ViewChild("menu") menu: ElementRef;
  isMenuOpen = false;

  @Input() _InfoEmpresa!: any;
  @Input() placement: any = "bottom";
  @Input() monthdisplay: any = "1";
  @Input() dropdownPosition: any = "bottom";
  @Input() isModal: any = false;
  @Input() lateral: any = false;
  @Output() eventEmit = new EventEmitter<any>();
  @Output() valorBuscar = new EventEmitter<any>();

  complemento: any;
  mostrarMenuMobileBus: any;
  valorBuscarFilterList: any;
  fechaIdaCalendario: NgbDateStruct;
  fechaVueltaCalendario: NgbDateStruct;
  todoElIdioma: any;
  idSelectedOrigin: string = '';
  idSelectedDestination: string = '';
  hiddenMobile: boolean;
  hiddenPc: boolean;
  deviceInfo = null;
  private readonly _fb = inject(FormBuilder);
  private deviceService = inject(DeviceDetectorService);
  newCmpl: string = '';
  loadingCitiesOrigin: boolean = false;
  loadingCitiesDestination: boolean = false;
  private translateSubscription: Subscription
  constructor(
    public ws: WebServicesService,
    // public fb: FormBuilder,
    public router: Router,
    public generalService: GeneralService,
    public sesion: SesionService,
    public activatedRoute: ActivatedRoute,
    private calendar: NgbCalendar,
    // public titleBrowser: Title,
    private renderer: Renderer2,
    // @Inject(PLATFORM_ID) private platformId: any,
    private modalService: NgbModal,
    private allLocalStorageService: AllLocalStorageService,
    private texto_sitio: Texto_sitio,
    private translateService: TranslateService,
  ) {
    this.ws.isMobile = this.deviceService.isMobile();
    this.ws.isTablet = this.deviceService.isTablet();
    this.ws.isDesktopDevice = this.deviceService.isDesktop();

    this.complemento = this.activatedRoute.snapshot.params.complement ? this.activatedRoute.snapshot.params.complement : 'pasajes';
    this.ws.newComplemt = this.activatedRoute.snapshot.params.complement ? this.activatedRoute.snapshot.params.complement : "pasajes";
    this.lang = this.translateService.currentLang

    //TODO: FALTA TERMINAR LA IMPLEMENTACION
    // this.generalService.updateComplement(this.ws.newComplemt);

    !this.ws.isMobile && !this.isMobile() ? this.hiddenMobile = true : this.hiddenPc = true

    this.form = this._fb.group({
      origin: [null, Validators.compose([Validators.required])],
      destination: [null, Validators.compose([Validators.required])],
      dateStart: [this.minDate, Validators.compose([Validators.required])],
      dateEnd: [null, []],
    });


    // ASIGNAR ORIGEN Y DESTINO SEGUN LA URL
    if (this.activatedRoute.snapshot.params.origen && this.activatedRoute.snapshot.params.destino) {
      let originUrl = this.activatedRoute.snapshot.params.origen;
      let destinationUrl = this.activatedRoute.snapshot.params.destino;

      if (originUrl && destinationUrl) {
        originUrl = originUrl.replace(/[-]/g, ' ');
        destinationUrl = destinationUrl.replace(/[-]/g, ' ');
        originUrl = this.capitalice(decodeURIComponent(originUrl));
        destinationUrl = this.capitalice(decodeURIComponent(destinationUrl));
        if (this.activatedRoute.snapshot.routeConfig.path.indexOf("/reg") != -1) {
          this.form.get("origin").setValue(destinationUrl);
          this.form.get("destination").setValue(originUrl);
        } else {
          this.form.get("origin").setValue(originUrl);
          this.form.get("destination").setValue(destinationUrl);
        }
      }
    } else {
      // ASIGNAR ORIGEN Y DESTINO SEGUN LOS ULTIMOS SELECCIONADOS 
      let dataHistorial: any = (typeof localStorage !== 'undefined') ? localStorage.getItem("SDJAMhfl") : "";
      if (dataHistorial) {
        try {
          dataHistorial = JSON.parse(dataHistorial);
          this.form.get("origin").setValue(dataHistorial.origin.city ? dataHistorial.origin.city : dataHistorial.origin);
          this.form.get("destination").setValue(dataHistorial.destination.city ? dataHistorial.destination.city : dataHistorial.destination);
        } catch (error) {

        }
      }
    }

    this.renderer.listen("window", "click", (e: Event) => {
      if (this.toggleButton && this.toggleButton.nativeElement) {
        if (
          !this.toggleButton.nativeElement.contains(e.target) &&
          !this.menu.nativeElement.contains(e.target)
        ) {
          this.isMenuOpen = false;
        }
      }
    });


    // if (this.lang == "es") {
    //   this.todoElIdioma = this.texto_sitio.spain.barra_busqueda;
    // } else {
    //   this.todoElIdioma = this.texto_sitio.english.barra_busqueda;
    // }

  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  capitalice(word: string) {
    if (!word) return word;
    return `${word[0].toUpperCase()}${word.substr(1).toLowerCase()}`;
  }


  ngOnDestroy(): void {
  }
  isMobile() {
    return (typeof window !== 'undefined') ? window.innerWidth <= 992 : false;
  }
  /**
   * Se ejecuta antes de recargar la pagina
   * Elimina datos almacenados para no cargar el origen y destino antiguo
   * @param event 
   */
  // @HostListener('window:beforeunload', ['$event'])
  // unloadHandler(event: Event) {
  //   if (this.ws.newComplemt == 'pasajes') {
  //     localStorage.setItem('reloadBar', 'true');
  //     localStorage.removeItem("SDJAMhfl")
  //     this.sesion.deleteDestinationCitiesPipe(this.complemento);
  //     this.form.get("origin").setValue(null);
  //     this.form.get("destination").setValue(null);
  //   } else {
  //     // localStorage.setItem('reloadBar', 'true');
  //   }
  // }

  modalOpenSLCIM(modalSLCIM) {
    this.modalService.open(modalSLCIM, { scrollable: true });
  }

  limpiarFechaVuelta() {
    this.dateEndMobile = null;
    this.dateEnd = null;
    this.form.get("dateEnd").setValue(null);
    this.opcionesFechaVuelta.defaultDate = null;
    this.opcionesFechaVuelta.minDate = null;
  }

  asignarEstilos() {
    if (this.activatedRoute.snapshot.params.complement == "cikbus") {
      let y = document.querySelector("body");
      y.setAttribute("style", "height: 100%; background-color: transparent !important; direction: ltr;");
      let e = document.querySelector("body");
      e.setAttribute("text-white", "color: white !important; text-shadow: 0 0 3px #000;");
    }
  }

  // eliminarPorDia() {
  //   let day: any = new Date().getDate();
  //   let month: any = new Date().getMonth() + 1;
  //   let year: any = new Date().getFullYear();
  //   day = day.toString();
  //   month = month.toString();
  //   year = year.toString();
  //   let amount = day + month + year;
  //   amount = Number(amount);
  //   const amount_last = (typeof localStorage !== 'undefined') ? localStorage.getItem("amount_last") : false;
  //   if (!amount_last) {
  //     (typeof localStorage !== 'undefined') ? localStorage.setItem("amount_last", amount) : false;
  //   }
  //   if (amount > amount_last) {
  //     if(typeof localStorage !== 'undefined'){
  //       localStorage.clear();
  //       localStorage.setItem("amount_last", amount);
  //     }
  //   }
  // }

  ngOnInit(): void {
    this.checkCities();
    this.asignarValorUrl();
    // this.generalService.newComplement$.subscribe(value => {
    //   this.newCmpl = value; 
    // });

    if (!this.activatedRoute.snapshot.params.fecha_ida && this.ws.newComplemt != "pasajes" && this.activatedRoute.snapshot.routeConfig.path.indexOf("/ida") != -1) {
      const origin = this.activatedRoute.snapshot.params.origen;
      const destination = this.activatedRoute.snapshot.params.destino;
      const date = this.dateFormat(new Date(), "dd-MM-yyyy");
      let newUrl: any = `/${this.lang}/${this.ws.newComplemt}/ida/${origin}/${destination}/${date}`;
      this.router.navigateByUrl(newUrl);
      return;
    }
    // this.eliminarPorDia();
    // this.asignarEstilos();

    this.initialize();

    // asignar valor fechas
    let fechaIda = this.activatedRoute.snapshot.params.fecha_ida;
    let fechaVuelta = this.activatedRoute.snapshot.params.fecha_vuelta;

    let dateMin;
    dateMin = new Date();
    dateMin = this.dateFormat(dateMin, "dd-MM-yyyy");
    dateMin = dateMin.split("-");
    dateMin = { year: Number(dateMin[2]), month: Number(dateMin[1]), day: Number(dateMin[0]) };

    setTimeout(() => {
      this.minDate = dateMin;
    }, 100);
    this.minDatePicker = dateMin;
    if (fechaIda) {
      let date;
      date = fechaIda;
      date = date.split("-");
      date = { year: Number(date[2]), month: Number(date[1]), day: Number(date[0]) };
      this.fechaIdaCalendario = date;
      this.onDateSelect(date);
    }

    if (fechaVuelta) {
      let date = fechaVuelta;
      date = date.split("-");
      date = { year: Number(date[2]), month: Number(date[1]), day: Number(date[0]) };
      this.fechaVueltaCalendario = date;
      this.minDateEnd = date;
      this.onDateSelectEnd(date);
    }

    this.muestraBarra = true;

    let date: any = new Date();
    date = this.dateFormat(date, "dd-MM-yyyy");
    date = date.split("-");

    this.onDateSelect({ year: Number(date[2]), month: Number(date[1]), day: Number(date[0]) });

    if (this.activatedRoute.snapshot.routeConfig.path.indexOf("ida") != -1) {
      this.abrirOrigenViajeWeb = false;
    }

    if (this.isModal == false) {
      this.cambiosFechaIda();
      this.cambiosFechaVuelta();
    }


  }

  cambiosFechaIda() {
    let date = this.form.value.dateStart;
    this.minDateEnd = date;
  }

  cambiosFechaVuelta() {
    let date = this.form.value.dateEnd;
    this.minDate = date;
  }

  asignarFechaHoy(type) {
    if (type == 0) {
      let date: any = new Date();
      date = this.dateFormat(date, "dd-MM-yyyy");
      date = date.split("-");
      this.fechaIdaCalendario = { year: Number(date[2]), month: Number(date[1]), day: Number(date[0]) };
    } else {
      let date: any = new Date();
      date = this.dateFormat(date, "dd-MM-yyyy");
      date = date.split("-");
      this.fechaVueltaCalendario = { year: Number(date[2]), month: Number(date[1]), day: Number(date[0]) };
    }
  }

  limpiarFecha() {
    this.fechaVueltaCalendario = null;
    this.form.get("dateEnd").setValue(null);
  }

  dateFormat(inputDate, format) {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    format = format.replace("MM", month.toString().padStart(2, "0"));
    if (format.indexOf("yyyy") > -1) {
      format = format.replace("yyyy", year.toString());
    } else if (format.indexOf("yy") > -1) {
      format = format.replace("yy", year.toString().substr(2, 2));
    }

    format = format.replace("dd", day.toString().padStart(2, "0"));
    return format;
  }

  /**
   * Cambia el origen por el destino 
   */
  intercambiar() {
    if (this.form.get('origin').valid && this.form.get('destination').valid) {
      // const origenSelectedPrev = JSON.parse(this.sesion.getOriginSelected(this.ws.newComplemt));
      // const destinoSelectedPrev = JSON.parse(this.sesion.getDestinationSelected(this.ws.newComplemt));
      const origin = this.form.get("origin").value;
      const destination = this.form.get("destination").value;

      this.form.get("origin").setValue(destination);
      this.form.get("destination").setValue(origin);

      // para mobile
      // this.sesion.saveOriginSelected(this.ws.newComplemt, destinoSelectedPrev);
      // this.sesion.saveDestinationSelected(this.ws.newComplemt, origenSelectedPrev);

      // almacena el nuevo origen y destino 
      if (this.form.value.origin && this.form.value.destination) {
        localStorage.setItem("SDJAMhfl", JSON.stringify(this.form.value));
      }
    }
  }

  /**
   * Levanta el modal para las fechas en mobile
   * @param type 
   * @param template 
   */
  open(type, template) {
    this.typeCalendar = type;
    this.title = type === 0 ? "Fecha de ida" : "Fecha de regreso";
    this.modalService.open(template);
  }

  close() {
    this.modalService.dismissAll();
  }

  resetStart() {
    this.dateStarMobile = "";
    this.form.get("dateStart").setValue(null);
  }

  resetEnd() {
    this.dateEndMobile = "";
    this.maxDateStart = "";
    this.form.get("dateEnd").setValue(null);
  }

  initialize(): void {

    this.formFiltroCiudadOrigen = this._fb.group({
      valor: [null],
    });

    this.cambiosFormularioFiltro();

    // iniciar calendario
    let date: any = new Date();
    date = this.dateFormat(date, "dd-MM-yyyy");
    date = date.split("-");
    this.fechaIdaCalendario = { year: Number(date[2]), month: Number(date[1]), day: Number(date[0]) };
  }

  cambiosFormularioFiltro() {
    this.formFiltroCiudadOrigen.valueChanges.subscribe((val) => {
      this.valorBuscarFilterList = val;
    });
  }

  validateForm(formGroup, nameForm) {
    let valid = true;
    let control: any = null;
    Object.keys(formGroup.controls).forEach((name) => {
      control = formGroup.controls[name].markAsTouched();
      if (formGroup.controls[name].errors) {
        valid = false;
      }
    });
    return valid;
  }

  onDateSelectEnd(even) {
    this.maxDateStart = even;
    this.form.get("dateEnd").setValue(even);
    this.cerrarModalBusquedaCiudades();
  }

  onDateSelect(even) {
    this.minDateEnd = even;
    this.dateStartMobile = this.fechaIdaCalendario;
    this.form.get("dateStart").setValue(even);
    this.cerrarModalBusquedaCiudades();
  }

  getDate(date) {
    let day = date.day < 10 ? `0${date.day}` : date.day;
    let month = date.month < 10 ? `0${date.month}` : date.month;
    return moment(`${date.year}-${month}-${day}`).format("DD-MM-YYYY");
  }

  /**
  * Busca las ciudades con el complemento actual
  * y almacena las ciudades en local
  */
  getCities(): void {
    const debeActualizarListaCiudades = this.sesion.checkoutResetCities(this.complemento);
    if (!debeActualizarListaCiudades) {
      const data = this.sesion.getCities(this.complemento);
      this.cities = data;
      this.loadingCitiesOrigin = false;
      this.loadingCitiesDestination = false;
      this.asignarValorUrl()
      this.muestraBarra = true;
      return;
    }

    this.ws.selectType("cities", { newComplemt: this.complemento }).then((res) => {
     
      const {success, response} = JSON.parse(res as string);

      this.cities = response

      this.loadingCitiesOrigin = false;
      this.loadingCitiesDestination = false;

      if (!this.cities || this.cities.length == 0) {
        const data = this.sesion.getCities(this.complemento);
        this.cities = data;
        this.loadingCitiesOrigin = false;
        this.loadingCitiesDestination = false;
        this.asignarValorUrl()
        this.muestraBarra = true;
        return;
      }

      this.sesion.deleteCitiesSaved(this.complemento);
      this.sesion.loadCities(this.cities, this.complemento);
      this.asignarValorUrl();
    }).catch((error: any) => {
      const data = this.sesion.getCities(this.complemento);
      this.cities = data;
      this.loadingCitiesOrigin = false;
      this.loadingCitiesDestination = false;
      this.asignarValorUrl()
      this.muestraBarra = true;
      return;
    });

    this.muestraBarra = true;
  }

  /**
   * Asigna el origen y destino en base 
   * a las ciudades que se encuentran en la url
   */
  asignarValorUrl() {
    // Get origin and destination from url
    let originUrl = this.activatedRoute.snapshot.params.origen;
    let destinationUrl = this.activatedRoute.snapshot.params.destino;
    originUrl = originUrl?.replace(/-/g, " ").toLowerCase();
    destinationUrl = destinationUrl?.replace(/-/g, " ").toLowerCase();

    // Set origin
    if (originUrl) {
      let cityOrigin = this.cities.find(cityObj => cityObj.city.toLowerCase().includes(originUrl));
      this.form.get("origin").setValue(cityOrigin?.city);
    } else {
      let originToSet = destinationUrl === 'santiago' ? null : this.cities[0]?.city;
      this.form.get("origin").setValue(originToSet);
    }

    // Set destination
    if (destinationUrl) {
      let cityDestination = this.cities.find(cityObj => cityObj.city.toLowerCase().includes(destinationUrl));
      this.form.get("destination").setValue(cityDestination?.city || this.cities[0].city);
    }

    // TODO: Check if this is needed
    // if (originUrl || destinationUrl) {
    //   if (this.activatedRoute.snapshot.routeConfig.path.indexOf("reg") != -1) {
    //     try {
    //       for (let item of this.cities) {
    //         let sizeVar = item.city.indexOf(",");
    //         let nameCity;
    //         if (sizeVar != -1) {
    //           nameCity = item.city.substring(0, sizeVar);
    //         } else {
    //           nameCity = item.city;
    //         }
    //         nameCity = nameCity.toLowerCase();
    //         if (nameCity == originUrl) {
    //           destinoAsignado = 1;
    //           destinoObj = item;
    //           if (this.ws.isMobile) {
    //             this.form.get("destination").setValue(item.city);
    //           }

    //           if (this.ws.isDesktopDevice || this.ws.isTablet) {
    //             this.form.get("destination").setValue(item);
    //           }
    //         }

    //         if (nameCity == destinationUrl) {
    //           origenAsignado = 1;
    //           origenObj = item;
    //           if (this.ws.isMobile) {
    //             this.form.get("origin").setValue(item.city);
    //           }

    //           if (this.ws.isDesktopDevice || this.ws.isTablet) {
    //             this.form.get("origin").setValue(item);
    //           }
    //         }
    //       }
    //     } catch (error) {

    //     }
    //   } else {
    //     for (let item of this.cities) {
    //       let sizeVar = item.city.indexOf(",");
    //       let nameCity;
    //       if (sizeVar != -1) {
    //         nameCity = item.city.substring(0, sizeVar);
    //       } else {
    //         nameCity = item.city;
    //       }
    //       nameCity = nameCity.toLowerCase();
    //       if (nameCity == originUrl) {
    //         origenAsignado = 1;
    //         origenObj = item;
    //         if (this.ws.isMobile) {
    //           this.form.get("origin").setValue(item.city);
    //         }

    //         if (this.ws.isDesktopDevice || this.ws.isTablet) {
    //           this.form.get("origin").setValue(item);
    //         }
    //       }

    //       if (nameCity == destinationUrl) {
    //         destinoAsignado = 1;
    //         destinoObj = item;
    //         if (this.ws.isMobile) {
    //           this.form.get("destination").setValue(item.city);
    //         }

    //         if (this.ws.isDesktopDevice || this.ws.isTablet) {
    //           this.form.get("destination").setValue(item);
    //         }
    //       }
    //     }
    //   }

    //   if (destinoAsignado == null) {
    //     this.form.get("destination").setValue(null);
    //     this.sesion.deleteDestinationSelected(this.complemento);
    //   }

    //   if (origenAsignado == null) {
    //     this.form.get("origin").setValue(null);
    //   }

    //   if (this.ws.isMobile) {
    //     if (this.form.get("origin").valid && origenObj) {
    //       this.sesion.saveOriginSelected(this.complemento, origenObj);
    //     }

    //     if (this.form.get("destination").valid && destinoObj) {
    //       this.sesion.saveDestinationSelected(this.complemento, destinoObj);
    //     }

    //   }
    // }
  }

  cerrarModalBusquedaCiudades() {
    if (typeof document !== 'undefined') {
      let element: HTMLElement = document.getElementsByClassName("cerrarModalBusqueda")[0] as HTMLElement;
      if (element) {
        element.click();
      }
    }
  }

  /**
   * Se emite cuando se selecciona un origen o destino en el modal mobile
   * @param event 
   */
  onEmit(event) {
    if (this.typeList == 0) {
      this.form.get("origin").setValue(event.city);
      // this.sesion.saveOriginSelected(this.ws.newComplemt, event);
      // if (this.form.get("destination").valid) {
      //   this.form.get("destination").setValue(null);
      // }
      this.cerrarModalBusquedaCiudades();
    }

    if (this.typeList == 1) {
      // this.sesion.saveDestinationSelected(this.ws.newComplemt, event);
      this.form.get("destination").setValue(event.city);
      if (this.form.value.origin && this.form.value.destination) {
        localStorage.setItem("SDJAMhfl", JSON.stringify(this.form.value));
        // localStorage.removeItem("reloadBar");
      }
      this.cerrarModalBusquedaCiudades();
    }
  }

  /**
   * Modifica los inputs de las busqueda
   * origin, destination y dateStart
   * @param item 
   */
  cambiarBusqueda(item) {
    this.form.get("origin").setValue(item.origin);
    this.form.get("destination").setValue(item.destination);
    this.form.get("dateStart").setValue(item.fechaIda);
    this.searchBus();
  }

  cerrarModal() {
    this.formFiltroCiudadOrigen.reset();
  }

  onClose(event) {
    if (this.modalRef) {
      this.modalRef.close();
    }
    this.showList = false;
  }

  // loadSesion() {
  //   let self = this;
  //   self.history = "";
  //   if (self.history) {
  //     let origin = self.history.origin["city"] ? self.history.origin.city : self.history["origin"];
  //     let destination = self.history.destination["city"] ? self.history.destination.city : self.history["destination"];

  //     self.form.get("origin").setValue(origin);
  //     self.form.get("destination").setValue(destination);
  //   }
  // }

  ngAfterViewInit(): any {
    // this.loadSesion();



    if (this.activatedRoute.snapshot.params.company) {
      this.complemento = this.activatedRoute.snapshot.params.company;
      this.ws.newComplemt = this.activatedRoute.snapshot.params.company;
    }

    // excepcion para cikbus
    if (this.complemento == 'buses-cikbus') {
      this.complemento = "cikbus";
      this.ws.newComplemt = "cikbus";
    }


  }

  /**
   * Levanta el modal de origen para mobile
   * @param template 
   * @param modalSLCIM 
   */
  openOrigin(template, modalSLCIM) {
    this.titleList = "Ingresa tu <b>Origen</b>";
    this.placeholder = "escriba el nombre de la ciudad...";
    this.typeList = 0;
    this.excludeList = 0;
    this.modalService.open(modalSLCIM, { scrollable: true });
  }

  /**
   * Levanta el modal de destino para mobile
   * @param template 
   * @param modalSLCIM 
   */
  openDestination(template, modalSLCIM) {
    this.titleList = "Ingresa tu <b>Destino</b>";
    this.placeholder = "escriba el nombre de la ciudad...";
    this.typeList = 1;
    this.excludeList = 0;
    this.modalService.open(modalSLCIM, { scrollable: true });
  }

  formularioBusquedaInvalido(content) {
    Swal.fire({
      title: "Ups!!",
      text: content,
      icon: "warning",
      showCancelButton: false,
      allowOutsideClick: false,
      confirmButtonColor: "var(--primary)",
      confirmButtonText: "Ok",
    });
  }

  /**
   * Verifica el origen y destino
   * @returns 
   */
  async viewTravels(): Promise<void> {
    let content: any;
    if (!this.form.value.origin) {
      content = await this.generalService.getTranslation('barra_busqueda.seleccioneOrigen');
      this.formularioBusquedaInvalido(content);
      return;
    }

    if (!this.form.value.destination) {
      content = await this.generalService.getTranslation('barra_busqueda.seleccioneDestino');
      this.formularioBusquedaInvalido(content);
      return;
    }

    if (this.form.value.origin == this.form.value.destination) {
      content = await this.generalService.getTranslation('barra_busqueda.origenYDestino');
      this.formularioBusquedaInvalido(content);
      return;
    }

    if (!this.form.value.dateStart) {
      let date = new Date();
      this.form.get("dateStart").setValue([date]);
    }

    this.searchBus();

    if (window.location.href.indexOf("/buscador") != -1) {
      return;
    }

    localStorage.removeItem("H15T0R14L_P4G0");
    const dayReg = new Date(this.form.value.dateEnd).getDate();
    const monthReg = new Date(this.form.value.dateEnd).getMonth() + 1;
    const yearReg = new Date(this.form.value.dateEnd).getFullYear();

    if (this.form.value.dateEnd) {
      this.dateEnd = { year: yearReg, month: monthReg, day: dayReg };
    } else {
      this.dateEnd = null;
    }

    const diaActual = new Date().getDate();
    const mesActual = new Date().getMonth() + 1;
    const annoActual = new Date().getFullYear();
    const fechaActual = diaActual + mesActual + annoActual;
    const fechaForm = this.form.value.dateStart.year + this.form.value.dateStart.month + this.form.value.dateStart.day;

    if (fechaForm < fechaActual) {
      this.form.get("dateStart").setValue({ year: annoActual, month: mesActual, day: diaActual });
    }

    let origen = this.form.value.origin.city ? this.form.value.origin.city : this.form.value.origin;
    let destino = this.form.value.destination.city ? this.form.value.destination.city : this.form.value.destination;

    if (origen == destino) {
      content = await this.generalService.getTranslation('barra_busqueda.origenYDestino');
      this.formularioBusquedaInvalido(content);
      return;
    }

    localStorage.setItem("SDJAMhfl", JSON.stringify(this.form.value));

    let y = document.querySelector("body");
    y.setAttribute("style", "overflow: display !important;");
    localStorage.setItem(`formClp-${this.ws.newComplemt}`, JSON.stringify(this.form.value));
    localStorage.removeItem(`recargarConReg-${this.ws.newComplemt}`);
    this.allLocalStorageService.eliminarHistorialViajeIda(this.ws.newComplemt);
    this.allLocalStorageService.eliminarSesionID(this.ws.newComplemt);
    this.allLocalStorageService.eliminarAsientosIda(this.ws.newComplemt);
    this.allLocalStorageService.eliminarAsientosVuelta(this.ws.newComplemt);
    this.allLocalStorageService.eliminarViajeIda(this.ws.newComplemt);
    this.allLocalStorageService.eliminarViajeVuelta(this.ws.newComplemt);
    localStorage.removeItem(`4pd4t3c1t135p40g4355-${this.ws.newComplemt}`);
    localStorage.removeItem(`formClp-${this.ws.newComplemt}`);
    this.modalService.dismissAll();
  }

  searchBus() {
    // this.validateForm(this.form, "search") &&
    let origin = this.form.value.origin["city"] ? this.form.value.origin.city.split(",") : this.form.value.origin.split(",");
    let destination = this.form.value.destination["city"] ? this.form.value.destination.city.split(",") : this.form.value.destination.split(",");
    let date = this.getDate(this.form.value.dateStart);
    origin = origin[0];
    destination = destination[0];
    origin = origin.replace(/ /g, "-");
    destination = destination.replace(/ /g, "-");
    origin = origin.split();
    destination = destination.split();
    this.sesion.saveSearch({
      origin: this.form.value.origin["city"] ? this.form.value.origin.city.split(",") : this.form.value.origin.split(","),
      destination: this.form.value.destination["city"] ? this.form.value.destination.city.split(",") : this.form.value.destination.split(","),
      fechaIda: this.form.get("dateStart").value
    });
    let currentUrl;
    if (window.location.href.indexOf("/buses/") != -1) {
      this.ws.newComplemt = "pasajes";
    }

    this.deleteInfoLocal();

    if (this.ws.newComplemt == "pasajes") {
      this.sesion.resetBack();
      this.allLocalStorageService.eliminarViajeIda(this.ws.newComplemt);
      this.allLocalStorageService.eliminarViajeVuelta(this.ws.newComplemt);
      if (this.form.get("dateEnd").value) {
        let dateEnd = this.getDate(this.form.value.dateEnd);
        currentUrl = [`${this.lang}/${this.ws.newComplemt}/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}/${dateEnd}`,];
      } else {
        currentUrl = [`${this.lang}/${this.ws.newComplemt}/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}`];
      }

      if (this.isModal === true) {
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
          this.router.navigate(currentUrl, { replaceUrl: true });
          this.eventEmit.emit(true);
        });
      } else {
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
          this.router.navigate(currentUrl, { replaceUrl: true });
          this.eventEmit.emit(true);
        });
      }
    } else {
      if (this.ws.newComplemt == "pasajes-buscador") {
        if (this.form.get("dateEnd").value) {
          let dateEnd = this.getDate(this.form.value.dateEnd);
          window.parent.location.href = `${this.lang}/pasajes/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}/${dateEnd}`;
        } else {
          window.parent.location.href = `${this.lang}/pasajes/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}`;
        }
      } else if (this.ws.newComplemt == "buses-pullmantur") {
        if (this.form.get("dateEnd").value) {
          let dateEnd = this.getDate(this.form.value.dateEnd);
          window.parent.location.href = `${this.lang}/buses-pullmantur/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}/${dateEnd}`;
        } else {
          window.parent.location.href = `${this.lang}/buses-pullmantur/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}`;
        }
      } else if (this.ws.newComplemt == "buses-paravias") {
        if (this.form.get("dateEnd").value) {
          let dateEnd = this.getDate(this.form.value.dateEnd);
          window.parent.location.href = `${this.lang}/buses-paravias/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}/${dateEnd}?utm_campaign=web-paravias&utm_medium=referral&utm_source=paravias`;
        } else {
          window.parent.location.href = `${this.lang}/buses-paravias/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}?utm_campaign=web-paravias&utm_medium=referral&utm_source=paravias`;
        }
      } else if (this.ws.newComplemt == "buses-transantin") {
        if (this.form.get("dateEnd").value) {
          let dateEnd = this.getDate(this.form.value.dateEnd);
          window.parent.location.href = `${environment.urlTransantin}/${this.lang}/buses-transantin/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}/${dateEnd}?utm_campaign=web-transantin&utm_medium=referral&utm_source=transantin`;
        } else {
          window.parent.location.href = `${environment.urlTransantin}/${this.lang}/buses-transantin/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}?utm_campaign=web-transantin&utm_medium=referral&utm_source=transantin`;
        }
      } else if (this.ws.newComplemt == "cikbus") {
        if (this.form.get("dateEnd").value) {
          let dateEnd = this.getDate(this.form.value.dateEnd);
          window.parent.location.href = `${this.lang}/${this.ws.newComplemt}/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}/${dateEnd}?utm_campaign=web-cikbus&utm_medium=referral&utm_source=cikbus`;
        } else {
          window.parent.location.href = `${this.lang}/${this.ws.newComplemt}/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}?utm_campaign=web-cikbus&utm_medium=referral&utm_source=cikbus`;
        }
      } else {
        if (this.form.get("dateEnd").value) {
          let dateEnd = this.getDate(this.form.value.dateEnd);
          window.parent.location.href = `${this.lang}/${this.ws.newComplemt}/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}/${dateEnd}`;
        } else {
          window.parent.location.href = `${this.lang}/${this.ws.newComplemt}/ida/${origin[0].toLowerCase().replace(" ", "-")}/${destination[0].toLowerCase().replace(" ", "-")}/${date}`;
        }
      }
    }
  }

  deleteInfoLocal() {
    localStorage.removeItem("ult_sess");
    localStorage.removeItem(`recargarConReg-${this.ws.newComplemt}`);
    this.allLocalStorageService.eliminarHistorialViajeIda(this.ws.newComplemt);
    this.allLocalStorageService.eliminarSesionID(this.ws.newComplemt);
    this.allLocalStorageService.eliminarAsientosIda(this.ws.newComplemt);
    this.allLocalStorageService.eliminarAsientosVuelta(this.ws.newComplemt);
    this.allLocalStorageService.eliminarViajeVuelta(this.ws.newComplemt);
    this.allLocalStorageService.eliminarViajeIda(this.ws.newComplemt);
    this.allLocalStorageService.eliminarDataPago(this.ws.newComplemt);
    this.allLocalStorageService.eliminarDatosClientePago(this.ws.newComplemt);

    localStorage.removeItem(`4pd4t3c1t135p40g4355-${this.ws.newComplemt}`);
    localStorage.removeItem(`formClp-${this.ws.newComplemt}`);
    localStorage.removeItem(
      `ch1l3p4s4g3sUs3435C0mpl3m3nt0-${this.ws.newComplemt}`
    );
    localStorage.removeItem(`iniciar_contador-${this.ws.newComplemt}`);
    localStorage.removeItem(`FISKNdks-${this.ws.newComplemt}`);
    localStorage.removeItem("eliminar_timer");
  }

  /**
   * Verifica si es necesario poder actualizar las ciudades almacenada en local
   */
  checkCities() {
    if (!this.activatedRoute.snapshot.params.origen || !this.activatedRoute.snapshot.params.destino) {
      const debeActualizarListaCiudades = this.sesion.checkoutResetCities(this.complemento);

      if (debeActualizarListaCiudades) {
        this.getCities();
        // this.form.get("origin").setValue(null);
        // this.form.get("destination").setValue(null);
      } else {
        const data = this.sesion.getCities(this.complemento);
        this.cities = data;
        this.loadingCitiesOrigin = false;
        this.loadingCitiesDestination = false;
      }
    }

    if (this.activatedRoute.snapshot.params.origen && this.activatedRoute.snapshot.params.destino) {
      this.getCities();
    }
  }

  /**
   * Despliega lista de ciudades para poder seleccionar origen en version desktop
   * @param agreeSelect 
   * @returns 
   */
  abrirOrigenDelViajeWeb(agreeSelect) {
    if (this.cities && this.cities.length === 0) {
      this.loadingCitiesOrigin = true;
      this.checkCities();
    }

    if (this.abrirOrigenViajeWeb == false) {
      this.form.get("origin").setValue(null);
      this.abrirOrigenViajeWeb = true;
      this.abrirDestinoViajeWeb = false;

      // elimina la seleccion del destino
      // if (this.form.get("destination").valid) {
      //   this.form.get("destination").setValue(null);
      // }
    } else {
      if (this.activatedRoute.snapshot.routeConfig.path.indexOf("ida") != -1) {
        this.abrirOrigenViajeWeb = !this.abrirOrigenViajeWeb;
      }
    }

    if (this.form.value.origin == null || this.activatedRoute.snapshot.routeConfig.path.indexOf("ida") != -1) {
      return;
    }

    if (this.abrirOrigenViajeWeb) {
      this.abrirOrigenViajeWeb = false;
      this.abrirDestinoViajeWeb = true;
      agreeSelect.focus();
    } else {
      this.abrirOrigenViajeWeb = true;
      this.abrirDestinoViajeWeb = false;
    }
  }

  /**
    * Despliega lista de ciudades para poder seleccionar destino en version desktop 
    * @returns 
    */
  abrirDestinoDelViajeWeb() {
    if (this.cities && this.cities.length == 0) {
      this.loadingCitiesDestination = true;
      this.checkCities();
    }

    if (this.abrirDestinoViajeWeb == false) {
      this.form.get("destination").setValue(null);
      this.abrirOrigenViajeWeb = false;
      this.abrirDestinoViajeWeb = true;
    } else {
      if (this.activatedRoute.snapshot.routeConfig.path.indexOf("ida") != -1) {
        this.abrirOrigenViajeWeb = false;
        this.abrirDestinoViajeWeb = !this.abrirDestinoViajeWeb;
      }
    }

    if (this.form.value.destination == null || this.activatedRoute.snapshot.routeConfig.path.indexOf("ida") != -1) {
      let element: HTMLElement = document.getElementsByClassName('hoy-btn')[0] as HTMLElement;
      if (element) {
        element.click();
      }
      return;
    }
    this.abrirDestinoViajeWeb = false;
    this.abrirOrigenViajeWeb = false;
    let element: HTMLElement = document.getElementsByClassName('abrirFechaIdaWeb')[0] as HTMLElement;
    element.click();
  }
}
